export enum LayerType {
  LAYER = 'layer',
  SHIMPAPER = 'separator',
}
